import React from 'react';
import { Grid, Chip, CircularProgress, Tooltip, Typography } from '@mui/material';
import InputFields from 'routes/Pages/components/InputFields/InputFields';

import { DropzoneUpload } from './InputsRendered';
import { Box } from '@material-ui/core';
import { EmployeeNameField } from 'routes/Pages/GenTask/components/SharedFormFields';

const HfexpenseClaimform = ({
  expenseData,
  setExpenseData,
  files,
  isLoading,
  handleFileChange,
  handleDeleteFiles,
  viewFile,
}) => {
  const handleChangeData = (name, value) => {
    let updatedData = {
      [name]: value,
    };

    setExpenseData(prevData => ({
      ...prevData,
      ...updatedData,
    }));
  };
  return (
    <Grid
      container
      spacing={1}
      sx={{
        '& .MuiTableCell-root': {
          fontSize: '0.825rem',
        },
        '& .MuiInputBase-root': {
          fontSize: '0.825rem !important',
        },
        paddingBottom: '1rem',
      }}>
      <EmployeeNameField value={expenseData['employeeName']} onChange={handleChangeData} isOperator={true} />
      <InputFields
        label="Expense Claim"
        helperText={'Enter Expense Amount'}
        name="expenseClaim"
        required={true}
        value={expenseData['expenseClaim']}
        textFieldType={'number'}
        width={4}
        handleIpChange={handleChangeData}
      />

      <Grid item xs={12} sm={12} md={6}>
        <DropzoneUpload label="File Upload" onFileSelect={handleFileChange('files')} multiple={true} />

        <Box
          sx={{
            display: 'flex',
            overflowX: 'auto',
            gap: 1,
            py: 1,
            px: 0.5,
            alignItems: 'center',
            minHeight: 60,
          }}>
          {isLoading ? (
            <Box sx={{ display: 'flex' }}>
              <CircularProgress size={22} />
              <Typography style={{ marginLeft: 8 }}>Fetching Docs ...</Typography>
            </Box>
          ) : files && files?.length > 0 ? (
            files.map((file, index) => (
              <Tooltip title={file.docName} key={index}>
                <div>
                  <Chip
                    label={file?.documentName?.length > 20 ? file.documentName.slice(0, 18) + '…' : file.documentName}
                    color="success"
                    sx={{ fontSize: '0.7rem', height: '24px', px: 1 }}
                    onDelete={() => handleDeleteFiles(file)}
                    onClick={() => viewFile(file)}
                  />
                </div>
              </Tooltip>
            ))
          ) : (
            <Typography>No files uploaded.</Typography>
          )}
        </Box>
      </Grid>

      <InputFields
        label="Additional Information"
        name="additionalInformation"
        required={false}
        value={expenseData['additionalInformation']}
        textFieldType={'text'}
        multiline={true}
        width={12}
        handleIpChange={handleChangeData}
      />
    </Grid>
  );
};

export default HfexpenseClaimform;
